import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  userCard: {
    height: '200px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    border: '1px solid rgba(0,0,0,0.08)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'relative',
    boxShadow: '0 0 2px 0 rgb(145 158 171 / 24%), 0 16px 32px -4px rgb(145 158 171 / 24%)'
  }
});

export default function UserTypeCard({ title, icon, handleClick }) {
  const classes = useStyles();
  return (
    <Box className={classes.userCard} onClick={() => handleClick(title)}>
      <img src={icon} alt={`${title} icon`} />
      <span style={{ fontSize: '18px', marginTop: '10px' }}>{title}</span>
    </Box>
  );
}

UserTypeCard.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  handleClick: PropTypes.func
};
